module.exports = __webpack_public_path__ + "static/img/业务-3.59d2b134.png";